import { Component } from 'angular-ts-decorators';

/**
 * Renders the top bar/nav bar. Should be run
 * in index.html
 */
@Component({
  selector: 'swSubheader',
  template: require('./sw-subheader.html').default,
  transclude: true,
})
export class SwSubheaderComponent {
  constructor() {
    'ngInject';
  }
}
